import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateOptions } from '@/actions/wizard/RequestWizardActions';
import { useStep } from './useStep';
import { usePrevious } from '@/utils/hooks';

const useValidation = () => {
    const dispatch = useDispatch();
    const { meta } = useSelector((state) => state.requestWizard);
    const { activeStep, steps: allSteps } = useStep();
    const prevStep = usePrevious(activeStep);

    useEffect(() => {
        if (
            prevStep &&
            prevStep.skippable &&
            !prevStep.isComplete &&
            !prevStep.error &&
            prevStep.name !== activeStep.name
        ) {
            completeStep(true, prevStep.name);
        }
    }, [activeStep]);

    // Update a specific step in Redux without overwriting other steps
    const updateStepInRedux = (stepName, updates) => {
        dispatch((dispatch, getState) => {
            const currentSteps = getState().requestWizard.options.steps;
            const updatedSteps = currentSteps.map((step) =>
                step.name !== stepName
                    ? step
                    : { ...step, ...updates }
            );
            dispatch(updateOptions('steps', updatedSteps));
        });
    };

    const completeStep = (completed = true, step = false) => {
        const stepToComplete = step ? step : meta.stepName;
        updateStepInRedux(stepToComplete, {
            isComplete: completed ? true : false,
            error: false,
        });
    };

    const stepError = (error = true, step = false) => {
        const stepWithError = step ? step : meta.stepName;
        updateStepInRedux(stepWithError, {
            isComplete: false,
            error,
        });
    };

    return { steps: allSteps, completeStep, stepError };
};

export default useValidation;
